<template>
  <div>
    <CModal
      :title="$t('newUser')"
      color="primary"
      centered
      :closeOnBackdrop="false"
      size="xl"
      :show.sync="$store.state.newUserModal"
      @update:show="changeShowStatus"
    >
      <template #header>
        <h6 class="modal-title">{{$t('newUser')}}</h6>
        <CButtonClose @click="() => {
          $store.commit('setNewUserModal', false)
          resetModal()
        }" class="text-white"/>
      </template>
      <CCard>
        <CCardBody>
          <CForm>
            <CRow>
              <CCol sm="12" md="6">
                <CInput
                  v-model="newUser.nombre"
                  :label="$t('name')"
                  :placeholder="$t('enterName')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CInput
                  v-model="newUser.apellido"
                  :label="$t('lastName')"
                  :placeholder="$t('enterLastname')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <CSelect
                  :value.sync="newUser.sexo"
                  :label="$t('gender')"
                  horizontal
                  :options="[{label: $t('female'), value: 'Femenino'}, {label: $t('male'), value: 'Masculino'}]"
									:reduce="data => data.value"
                  :placeholder="$t('selectGender')"
                />
                <CInput
                  v-model="newUser.nacimiento"
                  :label="$t('birth')"
                  type="date"
                  :min="setDate(1)"
                  :max="setDate(2)"
                  :description="$t('birthDescription')"
                  horizontal
                  :isValid="needValidation ? required && minDate:undefined"
                />
                <CInput
                  v-model="newUser.email"
                  :label="$t('email')"
                  :placeholder="$t('enterEmail')"
                  type="email"
                  horizontal
                  :isValid="needValidation ? required && email:undefined"
                />
              </CCol>
              <CCol>
								<CInput
									v-model="newUser.rut"
									label="Rut"
									description="Rut (Sin puntos ni guión). Ej. 11111111K"
									placeholder="Rut (Sin puntos ni guión)"
									horizontal
									required
								/>
                <CInput
                  v-model="newUser.telefono"
                  :label="$t('phone')"
                  :placeholder="$t('enterPhone')"
                  horizontal
                  :prepend="phonecode"
                  :isValid="needValidation ? required:undefined"
                />
                <CInput
                  v-model="newUser.direccion"
                  :label="$t('address')"
                  :placeholder="$t('enterAddress')"
                  horizontal
                  :isValid="needValidation ? required:undefined"
                />
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('country')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectCountry')"
                      :options="$store.state.countries"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      @option:selected="(country) => {
                        phonecode = '+' + country.phonecode
                        getStates(country.id)
                        newUser.region = null
                        newUser.comuna = null
                      }"
                      required
                      :isValid="needValidation ? required:undefined"
                      v-model="newUser.pais"></v-select>
                  </div>
                </div>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('region')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectRegion')"
                      :options="$store.state.states"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      @option:selected="(state) => {
                        getComunas(state.id)
                        newUser.comuna = null
                      }"
                      :isValid="needValidation ? required:undefined"
                      v-model="newUser.region"></v-select>
                  </div>
                </div>
                <div role="group" class="form-group form-row">
                  <label class="col-form-label col-sm-3"> {{$t('comuna')}} </label>
                  <div class="col-sm-9">
                    <v-select
                      :placeholder="$t('selectComuna')"
                      :options="$store.state.comunas"
                      label="name"
                      :clearable="false"
                      :reduce="data => data.name"
                      taggable
                      :createOption="option => ({name:option})"
                      :isValid="needValidation ? required:undefined"
                      v-model="newUser.comuna"></v-select>
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCol sm="12" md="12">
								<h5 class="bg-primary text-white text-center py-2">{{$t('userDocumentsTitle')}}</h5>
              </CCol>
              <CCol sm="12" md="12">
								<CButton block color="primary" @click="onButtonClick" ><CIcon name="cil-check-circle"/> {{$t('addAttachment')}}</CButton>
								<input
									ref="uploader"
									class="d-none"
									type="file"
									accept="image/*,.pdf"
									@change="onFileChanged"
								>
              </CCol>
            </CRow>
            <CRow v-for="(file, index) in files" :key="index" class="mx-2 my-1 bg-secondary py-2 rounded-lg" alignVertical="center">
              <CCol sm="12" md="3">
								<div class="d-flex flex-row align-items-center">
									<CButtonClose class="mr-2" @click="files.splice(index, 1)"/>
									<p class="mb-0">{{file.file.name}}</p>
								</div>
              </CCol>
              <CCol sm="12" md="3">
                <CInput
                  v-model="file.title"
                  :label="$t('title')"
                  :placeholder="$t('enterTitle')"
									class="mb-0"
                  :isValid="needValidation ? required:undefined"
                />
              </CCol>
              <CCol sm="12" md="6">
                <CInput
                  v-model="file.description"
                  :label="$t('description')"
                  :placeholder="$t('enterDescription')"
									class="mb-0"
                  :isValid="needValidation ? required:undefined"
                />
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
      <div slot="footer" class="d-flex align-items-center justify-end">
        <CBadge v-if="showRequiredAlert" color="warning" class="mx-2 px-2 py-1 text-white"><CIcon name="cil-bell"/> {{$t('allFieldsRequired')}}</CBadge>
        <CButton type="submit" color="primary" @click="sendForm" :disabled="loading"><CIcon name="cil-check-circle"/> {{$t('createUser')}}</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
import {required, email, minDate} from '@/helpers/validators'
import {getCountries, getStates, getComunas} from '@/helpers/api/regionalization.js'
import {createUser, createUserProfile} from '@/helpers/api/users.js'
import { clean } from 'rut.js'
import moment from 'moment'

export default {
  name: 'NewUserModal',
  data () {
    return {
      needValidation: false,
      showRequiredAlert: false,
      loading: false,
      phonecode: '',
			files: [],
      newUser: {
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        nacimiento: null,
        sexo: 'Femenino',
        img_url: 'defecto.png',
        direccion: '',
        pais: null,
        region: null,
        comuna: null,
      }
    }
  },
  mounted(){
    this.getCountries()
  },
  methods: {
    required, email, minDate,
    onButtonClick() {
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      const newFile = e.target.files[0]
      this.files.push({
				title: '',
				description: '',
				file: newFile
			})
			console.log("FILES: ", this.files)
    },
    setDate(type){
      let date = new Date()
      if(type == 1){
        date.setFullYear( date.getFullYear() - 100 )
      }
      else{
        date.setFullYear( date.getFullYear() - 13 )
      }
      return date.toISOString().split("T")[0]
    },
    changeShowStatus(status){
      this.resetModal()
    },
    resetModal(){
      this.needValidation = false
      this.showRequiredAlert = false
      this.loading = false
			this.newFile = null
      this.newUser = {
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        nacimiento: null,
        sexo: 'Femenino',
        img_url: 'defecto.png',
        direccion: '',
        pais: null,
        region: null,
        comuna: null,
      }
    },
    async getCountries(){
      const countries = await getCountries()
      if(countries.countries){
        this.$store.commit('setCountries', countries.countries)
      }
    },
    async getStates(country_id){
      const states = await getStates({country_id})
      if(states.states){
        this.$store.commit('setStates', states.states)
      }
    },
    async getComunas(state_id){
      const comunas = await getComunas({state_id})
      if(comunas.cities){
        this.$store.commit('setComunas', comunas.cities)
      }
    },
    isValidForm(){
      this.needValidation = true
			const age = moment().diff(moment(this.newUser.nacimiento, 'YYYY-MM-DD'), 'years')
			if(age < 13){
				this.$store.commit('addToast', {
					color: 'warning',
					header: 'Error',
					message: 'La edad debe ser mayor a 13 años'
				})
				return false
			}
      return Object.keys(this.newUser).every((key) => {
        return !!this.newUser[key]
      })
    },
    async sendForm(){
      if(this.isValidForm()){
        this.loading = true
        try{
          let completed = false
					let userData = {...this.newUser, ...{
            lang: this.$i18n.locale,
            parent_user_id: this.$store.state.userData.id_usuario,
            type: 2,
          }}
					console.log(userData)
          const user = await createUser(userData)
          if(user.data){
						completed = true
						this.$store.dispatch('getUsersList', {type: 2})
						this.$store.commit('setNewUserModal', false)
						this.resetModal()
          }

          this.$store.commit('addToast', {
            color: completed ? 'success':'warning',
            header: completed ? this.$i18n.t('createdUser'):'Error',
            message: completed ? this.$i18n.t('okCreatedUser'):this.$i18n.t('errorCreatedUser')
          })
        }
        catch(e){
          console.log(e)

          this.$store.commit('addToast', {
            color: 'warning',
            header: 'Error',
            message: e.response.data.error.message.email ? e.response.data.error.message.email[0]:this.$i18n.t('errorMessage')
          })
        }
        this.loading = false
      }
      else{
        this.showRequiredAlert = true
      }
    }
  }
}
</script>